export const spotInstanceProductDescriptions = [
  "Linux/UNIX",
  "Red Hat Enterprise Linux",
  "SUSE Linux",
  "Windows",
];
